import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SubheaderModule } from '../subheader/subheader.module';
import { TranslateModule } from '@ngx-translate/core';
import { ExpireMessageComponent } from './expire-message/expire-message.component';



@NgModule({
  declarations: [DashboardComponent, ExpireMessageComponent],
  imports: [
    CommonModule,
    FormsModule,
    SubheaderModule,
    TranslateModule.forRoot()
  ],
  exports : [DashboardComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DashboardModule { }
